// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import AccountBookTwoToneSvg from "@ant-design/icons-svg/es/asn/AccountBookTwoTone";
import AntdIcon from '../components/AntdIcon';

var AccountBookTwoTone = function AccountBookTwoTone(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: AccountBookTwoToneSvg
  }));
};

AccountBookTwoTone.displayName = 'AccountBookTwoTone';
export default React.forwardRef(AccountBookTwoTone);